import CommunitiesTable from './CommunitiesTable';

export default CommunitiesTable;
